import { ConflictError } from "./conflict-error";

// Thrown when a return is booked for an article carrying `requiresTransferCarrierOnReturn` without
// naming the trolley it was loaded onto. The flag is the article's own answer to how it moves
// inside the building: a 3 m board does not travel in somebody's hands, so the leg has to say
// which device is carrying it or nobody can find the material once it leaves the door.
//
// The native gate screen asks for the scan before it sends, so reaching here means the guard is
// the last one standing — a hand-made request, or a flag set after the screen was opened. 409 like
// the other put-away refusals: fixed per booking rather than once, but configuration all the same.
export class TransferCarrierRequiredError extends ConflictError {
	constructor() {
		super("stock.transfer_carrier_required");
		this.name = "TransferCarrierRequiredError";
	}
}
